import { render, staticRenderFns } from "./ShippingMethodTransportationList.vue?vue&type=template&id=c72c81b0"
import script from "./ShippingMethodTransportationList.vue?vue&type=script&lang=js"
export * from "./ShippingMethodTransportationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports